type Props = {
  onFilePicked: (file: File | undefined) => void;
};

export const useFilePicker = ({ onFilePicked }: Props) => {
  const openFilePicker = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jpg,.jpeg,.png';
    input.onchange = (event) => {
      onFilePicked((event.target as HTMLInputElement).files?.[0]);
    };
    input.click();
  };

  return { openFilePicker };
};
